/**
 *  package name object defined for com.inq and its direct children
 */
window.com = window.com || {};
com.inq = com.inq || {};
com.inq.events = com.inq.events || {};
com.inq.net = com.inq.net || {};
com.inq.stage = com.inq.stage || {};
com.inq.ui = com.inq.ui || {};
com.inq.utils = com.inq.utils || {};
/* aria is for accessibility */
com.inq.aria = com.inq.aria || {};
com.inq.addons = com.inq.addons || {};
